<template>
  <div>
    <details-box-heading label="ODA verklaring" class="mb-1" />
    <div class="box-content mb-2">
      <span :class="['tag', odaStatus.tagClass]" style="height: 1.3em">{{ odaStatus.label }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import { odaStatusTag, OdaStatusData } from '@/util/odaStatus'
import DetailsPaneBase from './DetailsPaneBase.vue'

@Component({
  name: 'DetailsOdaStatus',
})
export default class DetailsOdaStatus extends DetailsPaneBase {
  get odaStatus() {
    // oda_status is null when Eleena could not be asked while loading the task.
    return odaStatusTag(this.components.oda_status as OdaStatusData | null)
  }
}
</script>
